import React from 'react';

export const Icon = {
  Loading: () => (
    <svg className='spinner' viewBox='0 0 50 50'>
      <circle
        className='path'
        cx={25}
        cy={25}
        r={20}
        fill='none'
        strokeWidth={5}
      />
    </svg>
  ),
  Upload: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28.921 26.992'>
      <path
        d='M17.031,23.136H2.571v7.712H31.491V23.136Zm12.532,3.856H25.707V25.064h3.856ZM9.319,11.568l7.712-7.712,7.712,7.712h-4.82v9.64H14.139v-9.64Z'
        transform='translate(-2.571 -3.856)'
      />
    </svg>
  ),
  Remove: () => (
    <svg
      viewBox='0 0 50 50'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M32.7182292,24.984375 L49.6625,8.03958333 C50.0692708,7.6328125 50.0692708,6.9734375 49.6625,6.56666667 L43.4026042,0.305208333 C43.2072917,0.109895833 42.9416667,0 42.6661458,0 C42.3901042,0 42.125,0.109895833 41.9296875,0.305208333 L24.984375,17.2505208 L8.0390625,0.305208333 C7.6484375,-0.0854166667 6.95677083,-0.0854166667 6.56614583,0.305208333 L0.305729167,6.56666667 C-0.101041667,6.9734375 -0.101041667,7.6328125 0.305729167,8.03958333 L17.2505208,24.984375 L0.305729167,41.9291667 C-0.101041667,42.3359375 -0.101041667,42.9953125 0.305729167,43.4020833 L6.56614583,49.6630208 C6.76145833,49.8583333 7.0265625,49.9682292 7.30260417,49.9682292 C7.57864583,49.9682292 7.84375,49.8583333 8.0390625,49.6630208 L24.984375,32.7177083 L41.9296875,49.6630208 C42.125,49.8583333 42.3901042,49.9682292 42.6661458,49.9682292 C42.9416667,49.9682292 43.2072917,49.8583333 43.4026042,49.6630208 L49.6630208,43.4020833 C50.0697917,42.9953125 50.0697917,42.3354167 49.6630208,41.9291667 L32.7182292,24.984375 Z'
          id='Path'
          fill='#3D5059'
          fillRule='nonzero'
        />
      </g>
    </svg>
  ),
  Image: () => (
    <svg
      viewBox='0 0 52 50'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M40.3577689,0.00438247012 C43.0625498,0.00438247012 45.3338645,1.88934263 45.9310757,4.41414343 C49.014243,4.50109562 51.4960159,7.03436255 51.4960159,10.1379482 L51.4960159,10.1379482 L51.4960159,44.2676295 C51.4960159,47.4260956 48.9263944,49.9957171 45.7679283,49.9957171 L45.7679283,49.9957171 L11.638247,49.9957171 C8.93346614,49.9957171 6.66215139,48.110757 6.06494024,45.5859562 C2.98177291,45.499004 0.5,42.9657371 0.5,39.8620518 L0.5,39.8620518 L0.5,8.61155378 C0.5,3.86553785 4.36125498,0.00438247012 9.10727092,0.00438247012 L9.10727092,0.00438247012 Z M20.977988,18.685304 C20.2973108,18.6746016 19.6768924,19.0190239 19.3289841,19.6088645 L19.3289841,19.6088645 L7.90219124,38.9837649 L7.90219124,44.2678287 C7.90219124,44.7333665 7.98844622,45.1788845 8.14472112,45.590239 C8.67988048,46.9994024 10.0436255,48.0038845 11.638247,48.0038845 L11.638247,48.0038845 L45.7679283,48.0038845 C47.827988,48.0038845 49.5039841,46.3278884 49.5039841,44.2678287 L49.5039841,44.2678287 L49.5039841,37.1901394 L46.0860558,34.0569721 L44.0940239,32.2309761 L43.8601594,32.0166335 C43.1721116,31.3858566 42.1114542,31.3596614 41.3931275,31.9555777 L41.3931275,31.9555777 L36.9139442,35.6713147 C36.1158367,36.3333665 35.1136454,36.6633466 34.0947211,36.6163347 L34.0947211,36.6163347 L36.4154382,40.8777888 C36.6784861,41.3608566 36.5000996,41.9657371 36.0170319,42.2288845 C35.8657371,42.311255 35.70249,42.3503984 35.5415339,42.3503984 C35.1885458,42.3503984 34.8466135,42.1624502 34.6659363,41.8305777 L34.6659363,41.8305777 L27.5144422,28.6988048 L22.5945219,19.664741 C22.2670319,19.063247 21.662749,18.6973108 20.977988,18.685304 Z M37.5171536,43.8274568 L37.6464143,43.8447211 C37.7101594,43.8566733 37.7729084,43.8765936 37.8326693,43.901494 C37.8934263,43.9263944 37.9511952,43.9572709 38.0049801,43.9931275 C38.059761,44.0289841 38.1105578,44.0708167 38.1563745,44.1166335 C38.2021912,44.1624502 38.2440239,44.213247 38.2798805,44.2680279 C38.3157371,44.3218127 38.3466135,44.3795817 38.3715139,44.4403386 C38.3964143,44.5 38.4163347,44.562749 38.4292829,44.6265936 C38.4422311,44.6903386 38.4482072,44.7560757 38.4482072,44.8208167 C38.4482072,44.8855578 38.4422311,44.9512948 38.4292829,45.0150398 C38.4163347,45.0787849 38.3964143,45.1415339 38.3715139,45.2012948 C38.3466135,45.2620518 38.3157371,45.3198207 38.2798805,45.3736056 C38.2440239,45.4283865 38.2021912,45.4791833 38.1563745,45.525 C38.1335657,45.5478088 38.1095618,45.5696215 38.0843625,45.590239 C38.0589641,45.6109562 38.0324701,45.6304781 38.0049801,45.648506 C37.9511952,45.6843625 37.8934263,45.715239 37.8326693,45.7401394 C37.7729084,45.7650398 37.7101594,45.7849602 37.6464143,45.7969124 C37.5826693,45.8098606 37.5169323,45.8168327 37.4521912,45.8168327 C37.3874502,45.8168327 37.3217131,45.8098606 37.2579681,45.7969124 C37.1942231,45.7849602 37.1314741,45.7650398 37.0717131,45.7401394 C37.0109562,45.715239 36.9531873,45.6843625 36.8994024,45.648506 C36.8719124,45.6305777 36.8454183,45.6109562 36.8200199,45.590239 C36.7949203,45.5696215 36.7708167,45.5478088 36.748008,45.525 C36.7021912,45.4791833 36.6603586,45.4283865 36.624502,45.3736056 C36.5886454,45.3198207 36.5577689,45.2620518 36.5328685,45.2012948 C36.5079681,45.1415339 36.4880478,45.0787849 36.4760956,45.0150398 C36.4631474,44.9512948 36.4561753,44.8855578 36.4561753,44.8208167 C36.4561753,44.7560757 36.4631474,44.6903386 36.4760956,44.6265936 C36.4880478,44.5628486 36.5079681,44.5000996 36.5328685,44.4403386 C36.5577689,44.3795817 36.5886454,44.3218127 36.624502,44.2680279 C36.6603586,44.213247 36.7021912,44.1624502 36.748008,44.1166335 C36.7938247,44.0708167 36.8446215,44.0289841 36.8994024,43.9931275 C36.9531873,43.9572709 37.0109562,43.9263944 37.0717131,43.901494 C37.1314741,43.8765936 37.1942231,43.8566733 37.2579681,43.8447211 C37.3864542,43.8188247 37.5179283,43.8188247 37.6464143,43.8447211 Z M40.3577689,1.99631474 L9.10727092,1.99631474 C5.45966135,1.99631474 2.49203187,4.96384462 2.49203187,8.61155378 L2.49203187,8.61155378 L2.49203187,39.8620518 C2.49203187,41.8149402 3.99840637,43.4215139 5.91005976,43.5835657 L5.91005976,43.5835657 L5.91005976,10.1379482 C5.91005976,6.97948207 8.47968127,4.40986056 11.6381474,4.40986056 L11.6381474,4.40986056 L17.7927291,4.40986056 C18.3428287,4.40986056 18.788745,4.85577689 18.788745,5.40587649 C18.788745,5.9559761 18.3428287,6.40189243 17.7927291,6.40189243 L17.7927291,6.40189243 L11.6381474,6.40189243 C9.57808765,6.40189243 7.90209163,8.07788845 7.90209163,10.1379482 L7.90209163,10.1379482 L7.90209163,35.0624502 L17.6131474,18.5968127 C18.3301793,17.3810757 19.6011952,16.6716135 21.0120518,16.6937251 C22.4233068,16.7178287 23.6689243,17.4723108 24.3440239,18.7118526 L24.3440239,18.7118526 L27.5090637,24.5236056 L29.2638446,27.7459163 L32.4064741,33.5164343 C32.7126494,34.0785857 33.2488048,34.4704183 33.87749,34.5911355 C34.5061753,34.7119522 35.1494024,34.5468127 35.6420319,34.1380478 L35.6420319,34.1380478 L40.1212151,30.4223108 C41.2527888,29.4836653 42.7960159,29.2948207 44.0939243,29.8376494 L44.0939243,29.8376494 L46.0859562,31.3544821 L49.5039841,34.487749 L49.5039841,10.1379482 C49.5039841,8.18505976 47.9976096,6.57848606 46.0858566,6.41653386 L46.0858566,6.41653386 L44.0938247,6.40199203 L25.7608566,6.40199203 C25.210757,6.40199203 24.7648406,5.9560757 24.7648406,5.4059761 C24.7648406,4.85587649 25.210757,4.40996016 25.7608566,4.40996016 L25.7608566,4.40996016 L43.8512948,4.40996016 C43.3161355,3.00079681 41.9523904,1.99631474 40.3577689,1.99631474 L40.3577689,1.99631474 Z M38.3365538,12.5560757 C41.1670319,12.5560757 43.4697211,14.8586653 43.4697211,17.689243 C43.4697211,20.5197211 41.1669323,22.8224104 38.3365538,22.8224104 C35.5060757,22.8224104 33.2033865,20.5196215 33.2033865,17.689243 C33.2033865,14.8588645 35.5060757,12.5560757 38.3365538,12.5560757 Z M38.3365538,14.5481076 C36.6044821,14.5481076 35.1954183,15.9571713 35.1954183,17.689243 C35.1954183,19.4213147 36.6044821,20.8303785 38.3365538,20.8303785 C40.0686255,20.8303785 41.4776892,19.4211155 41.4776892,17.689243 C41.4776892,15.9571713 40.0685259,14.5481076 38.3365538,14.5481076 Z M21.8418548,4.41211819 L21.9711155,4.42938247 C22.0348606,4.44233068 22.0976096,4.46125498 22.1573705,4.48615538 C22.2181275,4.51105578 22.2758964,4.54193227 22.3296813,4.57778884 C22.3844622,4.61364542 22.435259,4.65547809 22.4810757,4.70129482 C22.5268924,4.74711155 22.5687251,4.79890438 22.6045817,4.85268924 C22.6404382,4.90747012 22.6713147,4.96523904 22.6962151,5.025 C22.7211155,5.08476096 22.7410359,5.14750996 22.752988,5.21125498 C22.7659363,5.27599602 22.7729084,5.34073705 22.7729084,5.4064741 C22.7729084,5.47121514 22.7659363,5.53595618 22.752988,5.60069721 C22.7410359,5.66444223 22.7211155,5.72719124 22.6962151,5.78695219 C22.6713147,5.84671315 22.6404382,5.90448207 22.6045817,5.95926295 C22.5687251,6.01304781 22.5268924,6.06484064 22.4810757,6.11065737 C22.435259,6.1564741 22.3844622,6.19830677 22.3296813,6.23416335 C22.2758964,6.27001992 22.2181275,6.30089641 22.1573705,6.32579681 C22.0976096,6.35069721 22.0348606,6.36962151 21.9711155,6.38256972 C21.9073705,6.39551793 21.8416335,6.40249004 21.7768924,6.40249004 C21.7121514,6.40249004 21.6464143,6.39551793 21.5826693,6.38256972 C21.5189243,6.36962151 21.4561753,6.35069721 21.3954183,6.32579681 C21.3356574,6.30089641 21.2778884,6.27001992 21.2241036,6.23416335 C21.1693227,6.19830677 21.1185259,6.1564741 21.0727092,6.11065737 C21.0268924,6.06484064 20.9850598,6.01304781 20.9482072,5.95926295 C20.9123506,5.90448207 20.8824701,5.84671315 20.8575697,5.78695219 C20.8326693,5.72719124 20.812749,5.66444223 20.8007968,5.60069721 C20.7878486,5.53595618 20.7808765,5.47121514 20.7808765,5.4064741 C20.7808765,5.34073705 20.7878486,5.27599602 20.8007968,5.21125498 C20.812749,5.14750996 20.8326693,5.08476096 20.8575697,5.025 C20.8824701,4.96523904 20.9123506,4.90747012 20.9482072,4.85268924 C20.9850598,4.79890438 21.0268924,4.74711155 21.0727092,4.70129482 C21.1185259,4.65547809 21.1693227,4.61364542 21.2241036,4.57778884 C21.2778884,4.54193227 21.3356574,4.51105578 21.3954183,4.48615538 C21.4561753,4.46125498 21.5189243,4.44233068 21.5826693,4.42938247 C21.7111554,4.40348606 21.8426295,4.40348606 21.9711155,4.42938247 Z'
          id='Combined-Shape'
          fill='#3D5059'
          fillRule='nonzero'
        />
      </g>
    </svg>
  ),
  Checked: () => (
    <svg
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M11.771,6.75015599e-14 C14.917,6.75015599e-14 17.875,1.225 20.097,3.448 C24.689,8.039 24.689,15.51 20.099,20.103 C17.875,22.327 14.916,23.552 11.769,23.552 C8.623,23.552 5.666,22.328 3.443,20.104 C-1.149,15.512 -1.147,8.04 3.445,3.448 C5.669,1.225 8.626,6.75015599e-14 11.771,6.75015599e-14 Z M11.771,2 C9.16,2 6.705,3.017 4.859,4.862 C1.046,8.674 1.046,14.877 4.857,18.69 C6.703,20.536 9.158,21.552 11.769,21.552 C14.382,21.552 16.837,20.535 18.685,18.688 C22.496,14.876 22.496,8.674 18.683,4.862 C16.837,3.017 14.382,2 11.771,2 Z M16.9347,7.0444 C17.3627,7.3954 17.4237,8.0254 17.0737,8.4524 L11.3487,15.4314 C11.1677,15.6534 10.8997,15.7864 10.6127,15.7974 L10.5757,15.7974 L10.5757,15.7974 C10.3027,15.7974 10.0407,15.6854 9.8507,15.4864 L7.2577,12.7634 C6.8767,12.3634 6.8917,11.7304 7.2927,11.3494 C7.6907,10.9684 8.3237,10.9834 8.7067,11.3844 L10.5207,13.2884 L15.5267,7.1834 C15.8767,6.7584 16.5077,6.6934 16.9347,7.0444 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Info: () => (
    <svg
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M11.7774,6.75015599e-14 C14.9224,6.75015599e-14 17.8794,1.225 20.1034,3.448 C24.6934,8.039 24.6954,15.51 20.1054,20.103 C17.8794,22.327 14.9224,23.552 11.7734,23.552 C8.6294,23.552 5.6724,22.328 3.4494,20.104 C1.2244,17.881 0.000400000002,14.923 0.000400000002,11.776 C0.000400000002,8.63 1.2264,5.672 3.4514,3.448 C5.6734,1.225 8.6314,6.75015599e-14 11.7774,6.75015599e-14 Z M11.7774,2 C9.1664,2 6.7114,3.017 4.8654,4.862 C3.0174,6.709 2.0004,9.165 2.0004,11.776 C2.0004,14.389 3.0154,16.844 4.8634,18.69 C6.7094,20.536 9.1624,21.552 11.7734,21.552 C14.3864,21.552 16.8434,20.535 18.6914,18.688 C22.5024,14.876 22.5004,8.674 18.6894,4.862 C16.8434,3.017 14.3884,2 11.7774,2 Z M11.7289,9.2113 C12.0269,9.2113 12.2739,9.3123 12.4669,9.5163 C12.6599,9.7193 12.7559,10.0023 12.7559,10.3643 L12.7559,16.2363 C12.7559,16.6423 12.6599,16.9503 12.4669,17.1583 C12.2739,17.3673 12.0269,17.4713 11.7289,17.4713 C11.4319,17.4713 11.1899,17.3643 11.0039,17.1513 C10.8189,16.9383 10.7249,16.6333 10.7249,16.2363 L10.7249,10.4243 C10.7249,10.0223 10.8189,9.7193 11.0039,9.5163 C11.1899,9.3123 11.4319,9.2113 11.7289,9.2113 Z M11.7519,6.2793 C12.0159,6.2793 12.2479,6.3633 12.4509,6.5313 C12.6539,6.7003 12.7559,6.9463 12.7559,7.2683 C12.7559,7.5813 12.6559,7.8253 12.4589,8.0013 C12.2599,8.1773 12.0259,8.2653 11.7519,8.2653 C11.4689,8.2653 11.2269,8.1793 11.0259,8.0053 C10.8259,7.8323 10.7249,7.5863 10.7249,7.2683 C10.7249,6.9813 10.8279,6.7443 11.0329,6.5583 C11.2399,6.3723 11.4789,6.2793 11.7519,6.2793 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Warning: () => (
    <svg
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M11.7774,6.75015599e-14 C14.9224,6.75015599e-14 17.8814,1.225 20.1034,3.448 C24.6954,8.04 24.6954,15.511 20.1054,20.103 C17.8794,22.327 14.9224,23.552 11.7754,23.552 C8.6294,23.552 5.6724,22.328 3.4494,20.104 C1.2244,17.88 0.0004,14.923 0.0004,11.776 C0.0004,8.63 1.2264,5.672 3.4514,3.448 C5.6734,1.225 8.6314,6.75015599e-14 11.7774,6.75015599e-14 Z M11.7774,2 C9.1664,2 6.7114,3.017 4.8654,4.862 C3.0174,6.709 2.0004,9.164 2.0004,11.776 C2.0004,14.389 3.0174,16.844 4.8634,18.69 C6.7094,20.536 9.1644,21.552 11.7754,21.552 C14.3864,21.552 16.8434,20.535 18.6914,18.688 C22.5024,14.877 22.5024,8.674 18.6894,4.862 C16.8434,3.017 14.3884,2 11.7774,2 Z M11.6446,15.2315 C11.9566,15.2315 12.2186,15.3375 12.4336,15.5515 C12.6466,15.7645 12.7516,16.0275 12.7516,16.3395 C12.7516,16.6875 12.6406,16.9605 12.4176,17.1585 C12.1956,17.3565 11.9356,17.4565 11.6446,17.4565 C11.3416,17.4565 11.0766,17.3585 10.8516,17.1625 C10.6246,16.9665 10.5116,16.6925 10.5116,16.3395 C10.5116,16.0275 10.6216,15.7645 10.8396,15.5515 C11.0586,15.3375 11.3266,15.2315 11.6446,15.2315 Z M11.8226,6.1895 C12.5406,6.1895 13.1776,6.3225 13.7266,6.5875 C14.2776,6.8525 14.7036,7.2145 15.0036,7.6705 C15.3046,8.1265 15.4536,8.6235 15.4536,9.1585 C15.4536,9.5805 15.3696,9.9505 15.1976,10.2675 C15.0256,10.5855 14.8226,10.8595 14.5876,11.0895 C14.3516,11.3205 13.9276,11.7085 13.3186,12.2545 C13.1506,12.4085 13.0136,12.5435 12.9126,12.6605 C12.8106,12.7765 12.7346,12.8835 12.6856,12.9795 C12.6366,13.0765 12.5976,13.1735 12.5706,13.2705 C12.5426,13.3675 12.5016,13.5375 12.4476,13.7805 C12.3536,14.2965 12.0586,14.5545 11.5626,14.5545 C11.3046,14.5545 11.0856,14.4695 10.9106,14.3015 C10.7346,14.1325 10.6466,13.8815 10.6466,13.5495 C10.6466,13.1325 10.7106,12.7715 10.8396,12.4665 C10.9686,12.1615 11.1406,11.8935 11.3536,11.6635 C11.5666,11.4325 11.8556,11.1585 12.2166,10.8405 C12.5356,10.5625 12.7636,10.3525 12.9046,10.2115 C13.0466,10.0705 13.1656,9.9135 13.2616,9.7395 C13.3596,9.5655 13.4086,9.3775 13.4086,9.1735 C13.4086,8.7765 13.2596,8.4415 12.9646,8.1685 C12.6696,7.8965 12.2896,7.7595 11.8226,7.7595 C11.2776,7.7595 10.8746,7.8975 10.6176,8.1725 C10.3596,8.4485 10.1406,8.8535 9.9626,9.3895 C9.7926,9.9505 9.4726,10.2305 9.0016,10.2305 C8.7246,10.2305 8.4906,10.1325 8.2986,9.9365 C8.1076,9.7405 8.0116,9.5285 8.0116,9.3005 C8.0116,8.8295 8.1646,8.3515 8.4666,7.8675 C8.7696,7.3835 9.2106,6.9835 9.7906,6.6655 C10.3716,6.3485 11.0486,6.1895 11.8226,6.1895 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Danger: () => (
    <svg
      viewBox='0 0 27 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M14.1485,0.4648 L26.4315,21.7388 C26.6115,22.0488 26.6115,22.4288 26.4315,22.7388 C26.2535,23.0488 25.9235,23.2388 25.5665,23.2388 L1.0005,23.2388 C0.6425,23.2388 0.3125,23.0488 0.1345,22.7388 C-0.0445,22.4288 -0.0445,22.0488 0.1345,21.7388 L12.4165,0.4648 C12.7735,-0.1552 13.7915,-0.1552 14.1485,0.4648 Z M13.2835,2.9648 L2.7325,21.2388 L23.8345,21.2388 L13.2835,2.9648 Z M13.1501,16.541 C13.4371,16.541 13.6841,16.641 13.8851,16.838 C14.0881,17.037 14.1891,17.277 14.1891,17.56 C14.1891,17.879 14.0881,18.129 13.8831,18.312 C13.6781,18.494 13.4371,18.585 13.1641,18.585 C12.8871,18.585 12.6441,18.495 12.4351,18.314 C12.2281,18.135 12.1251,17.883 12.1251,17.56 C12.1251,17.277 12.2251,17.037 12.4221,16.838 C12.6211,16.641 12.8631,16.541 13.1501,16.541 Z M13.2051,8.235 C13.5981,8.235 13.8591,8.371 13.9921,8.643 C14.1231,8.913 14.1891,9.304 14.1891,9.814 C14.1891,10.115 14.1741,10.421 14.1431,10.731 L13.8481,14.101 C13.8161,14.502 13.7481,14.81 13.6431,15.023 C13.5391,15.237 13.3651,15.345 13.1231,15.345 C12.8771,15.345 12.7071,15.241 12.6111,15.033 C12.5161,14.826 12.4471,14.511 12.4061,14.087 L12.1871,10.813 C12.1461,10.175 12.1251,9.717 12.1251,9.439 C12.1251,9.061 12.2251,8.766 12.4221,8.553 C12.6211,8.342 12.8831,8.235 13.2051,8.235 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Close: () => (
    <svg
      viewBox='0 0 18 18'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M17.176,0.2927 C17.566,0.6837 17.566,1.3167 17.176,1.7067 L10.14775,8.7342 L17.1758,15.7612 C17.5668,16.1522 17.5668,16.7842 17.1758,17.1752 C16.9808,17.3702 16.7248,17.4682 16.4688,17.4682 C16.2128,17.4682 15.9568,17.3702 15.7618,17.1752 L8.73375,10.1472 L1.707,17.1747 C1.512,17.3697 1.256,17.4677 1,17.4677 C0.744,17.4677 0.488,17.3697 0.293,17.1747 C-0.098,16.7837 -0.098,16.1517 0.293,15.7607 L7.31975,8.7342 L0.2928,1.7072 C-0.0972,1.3172 -0.0972,0.6842 0.2928,0.2932 C0.6838,-0.0968 1.3168,-0.0968 1.7068,0.2932 L8.73375,7.3202 L15.762,0.2927 C16.152,-0.0973 16.785,-0.0973 17.176,0.2927 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Dashboard: () => (
    <svg
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M10.033,12.3664 C10.586,12.3664 11.033,12.8134 11.033,13.3664 L11.033,22.3994 C11.033,22.9524 10.586,23.3994 10.033,23.3994 L1,23.3994 C0.447,23.3994 -2.76223489e-13,22.9524 -2.76223489e-13,22.3994 L-2.76223489e-13,13.3664 C-2.76223489e-13,12.8134 0.447,12.3664 1,12.3664 L10.033,12.3664 Z M22.4,12.3664 C22.953,12.3664 23.4,12.8134 23.4,13.3664 L23.4,22.3994 C23.4,22.9524 22.953,23.3994 22.4,23.3994 L13.367,23.3994 C12.814,23.3994 12.367,22.9524 12.367,22.3994 L12.367,13.3664 C12.367,12.8134 12.814,12.3664 13.367,12.3664 L22.4,12.3664 Z M9.033,14.3664 L2,14.3664 L2,21.3994 L9.033,21.3994 L9.033,14.3664 Z M21.4,14.3664 L14.367,14.3664 L14.367,21.3994 L21.4,21.3994 L21.4,14.3664 Z M10.033,0.0004 C10.586,0.0004 11.033,0.4474 11.033,1.0004 L11.033,10.0334 C11.033,10.5854 10.586,11.0334 10.033,11.0334 L1,11.0334 C0.447,11.0334 -2.76223489e-13,10.5854 -2.76223489e-13,10.0334 L-2.76223489e-13,1.0004 C-2.76223489e-13,0.4474 0.447,0.0004 1,0.0004 L10.033,0.0004 Z M22.4,0.0004 C22.953,0.0004 23.4,0.4474 23.4,1.0004 L23.4,10.0334 C23.4,10.5854 22.953,11.0334 22.4,11.0334 L13.367,11.0334 C12.814,11.0334 12.367,10.5854 12.367,10.0334 L12.367,1.0004 C12.367,0.4474 12.814,0.0004 13.367,0.0004 L22.4,0.0004 Z M9.033,2.0004 L2,2.0004 L2,9.0334 L9.033,9.0334 L9.033,2.0004 Z M21.4,2.0004 L14.367,2.0004 L14.367,9.0334 L21.4,9.0334 L21.4,2.0004 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Place: () => (
    <svg
      viewBox='0 0 21 25'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M10.2519,-0.0001 C15.9039,-0.0001 20.5039,4.5989 20.5039,10.2509 C20.5039,15.6669 11.8849,23.1729 10.8999,24.0109 C10.7149,24.1699 10.4819,24.2499 10.2519,24.2499 C10.0219,24.2499 9.7909,24.1699 9.6039,24.0109 C8.6209,23.1729 -9.99999998e-05,15.6669 -9.99999998e-05,10.2509 C-9.99999998e-05,4.5989 4.5999,-0.0001 10.2519,-0.0001 Z M10.2519,1.9999 C5.7029,1.9999 1.9999,5.7009 1.9999,10.2509 C1.9999,13.7629 7.4589,19.4039 10.2519,21.9189 C13.0449,19.4039 18.5039,13.7629 18.5039,10.2509 C18.5039,5.7009 14.8029,1.9999 10.2519,1.9999 Z M10.2519,7.2509 C11.9059,7.2509 13.2519,8.5969 13.2519,10.2509 C13.2519,11.9049 11.9059,13.2509 10.2519,13.2509 C8.5979,13.2509 7.2519,11.9049 7.2519,10.2509 C7.2519,8.5969 8.5979,7.2509 10.2519,7.2509 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  User: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.6699 13.1309C18.0399 14.0609 18.9999 15.3209 18.9999 17.0009V20.0009H22.9999V17.0009C22.9999 14.8209 19.4299 13.5309 16.6699 13.1309Z'
        fill='#323232'
      />
      <path
        d='M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z'
        fill='#323232'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.9999 12C17.2099 12 18.9999 10.21 18.9999 8C18.9999 5.79 17.2099 4 14.9999 4C14.5299 4 14.0899 4.1 13.6699 4.24C14.4999 5.27 14.9999 6.58 14.9999 8C14.9999 9.42 14.4999 10.73 13.6699 11.76C14.0899 11.9 14.5299 12 14.9999 12Z'
        fill='#323232'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13Z'
        fill='#323232'
      />
    </svg>
  ),
  Collection: () => (
    <svg
      viewBox='0 0 24 18'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M0.5,6.03961325e-14 C0.777,6.03961325e-14 1,0.224 1,0.5 L1,16.918 C1,17.194 0.777,17.418 0.5,17.418 C0.225,17.418 0,17.194 0,16.918 L0,0.5 C0,0.224 0.225,6.03961325e-14 0.5,6.03961325e-14 Z M23.1661,6.03961325e-14 C23.4431,6.03961325e-14 23.6661,0.224 23.6661,0.5 L23.6661,16.918 C23.6661,17.194 23.4431,17.418 23.1661,17.418 C22.8911,17.418 22.6661,17.194 22.6661,16.918 L22.6661,0.5 C22.6661,0.224 22.8911,6.03961325e-14 23.1661,6.03961325e-14 Z M2.75,1.0973 C3.027,1.0973 3.25,1.3213 3.25,1.5973 L3.25,15.8203 C3.25,16.0963 3.027,16.3203 2.75,16.3203 C2.475,16.3203 2.25,16.0963 2.25,15.8203 L2.25,1.5973 C2.25,1.3213 2.475,1.0973 2.75,1.0973 Z M20.9161,1.0973 C21.1931,1.0973 21.4161,1.3213 21.4161,1.5973 L21.4161,15.8203 C21.4161,16.0963 21.1931,16.3203 20.9161,16.3203 C20.6411,16.3203 20.4161,16.0963 20.4161,15.8203 L20.4161,1.5973 C20.4161,1.3213 20.6411,1.0973 20.9161,1.0973 Z M18.127,1.416 C18.68,1.416 19.127,1.863 19.127,2.416 L19.127,15.002 C19.127,15.555 18.68,16.002 18.127,16.002 L5.541,16.002 C4.988,16.002 4.541,15.555 4.541,15.002 L4.541,2.416 C4.541,1.863 4.988,1.416 5.541,1.416 L18.127,1.416 Z M17.127,3.416 L6.541,3.416 L6.541,14.002 L17.127,14.002 L17.127,3.416 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Reaction: () => (
    <svg
      viewBox='0 0 24 25'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M13.7502,0.0005 C14.2682,0.0005 14.7772,0.2445 15.1872,0.6875 C16.0192,1.5905 16.4082,3.2245 16.2502,5.1695 C16.2302,5.4145 16.1912,5.6755 16.1522,5.9495 C16.1292,6.1055 16.1052,6.2645 16.0842,6.4265 C16.0702,6.6235 16.0592,6.8215 16.0512,7.0125 C16.5212,7.1915 17.7832,7.4085 19.8932,7.4085 L20.3072,7.4045 C22.1542,7.4045 23.6372,8.8875 23.6372,10.7105 C23.6372,11.4235 23.4102,12.0975 22.9902,12.6615 C23.0332,12.8915 23.0492,13.1255 23.0332,13.3595 C22.9942,14.1155 22.6542,14.8195 22.1022,15.3315 C22.1002,15.3475 22.1002,15.3635 22.0982,15.3785 C22.0452,16.3455 21.5002,17.2175 20.6662,17.7155 C20.6442,17.7875 20.6212,17.8565 20.5962,17.9265 C20.2282,18.9055 19.2172,19.4395 17.7442,19.4395 C17.4612,19.4395 17.1852,19.4165 16.9412,19.3855 C16.3422,19.3085 15.4262,19.2315 14.3812,19.1435 L12.8142,19.0085 C12.0073646,18.9361293 11.3614519,18.9299927 10.8604431,18.9551301 L11.5043,21.1401 C11.5803,21.3941 11.5513,21.6681 11.4243,21.9011 C11.2973,22.1341 11.0823,22.3071 10.8283,22.3821 L4.8143,24.1521 C4.7213,24.1801 4.6273,24.1921 4.5333,24.1921 C4.1013,24.1921 3.7033,23.9101 3.5743,23.4751 L0.0413,11.4771 C-0.1147,10.9481 0.1873,10.3921 0.7173,10.2361 L6.7283,8.4621 C6.9823,8.3861 7.2563,8.4151 7.4903,8.5431 C7.66963333,8.64126954 7.81431102,8.79142256 7.9053964,8.97231306 C9.08350087,7.81200378 10.4319342,6.248547 10.9982,5.2585 C11.4142,3.8045 11.2232,2.0585 11.2152,1.9835 C11.1642,1.5445 11.3012,1.1195 11.5962,0.7875 C12.2772,0.0225 13.6022,0.0005 13.7502,0.0005 Z M6.3343,10.6631 L2.2423,11.8711 L2.2563,11.9241 L5.2113,21.9521 L9.3033,20.7461 L8.70398896,18.711546 C8.63830883,18.6214777 8.58666555,18.5190059 8.5532,18.4065 L6.3982,11.0935 C6.36497778,10.9811222 6.35245284,10.8659904 6.35910627,10.7529746 L6.3343,10.6631 Z M13.6802,2.0035 C13.5432,2.0135 13.3672,2.0435 13.2302,2.0825 C13.2832,2.7895 13.3382,4.4595 12.8792,5.9445 C12.8592,6.0075 12.8342,6.0685 12.8032,6.1265 C12.0439694,7.52534278 10.0308715,9.78322638 8.55125434,11.1089383 L10.2832326,16.9905 L10.5030906,16.9715625 C10.789075,16.9501875 11.0932,16.9395 11.4142,16.9395 C11.8892,16.9395 12.4202,16.9655 12.9922,17.0165 L14.5492,17.1505 C15.6312,17.2425 16.5782,17.3225 17.1932,17.4025 C17.3552,17.4215 17.5472,17.4395 17.7442,17.4395 C18.4222,17.4395 18.6912,17.2695 18.7232,17.2275 C18.7562,17.1335 18.7812,17.0285 18.7932,16.9175 C18.8362,16.5375 19.0922,16.2145 19.4532,16.0865 C19.8262,15.9545 20.0822,15.6255 20.1032,15.2485 C20.1072,15.1685 20.1032,15.1075 20.0902,15.0305 C20.0162,14.6185 20.2072,14.2035 20.5702,13.9915 C20.8462,13.8295 21.0212,13.5505 21.0372,13.2455 C21.0472,13.0965 21.0192,12.9545 20.9572,12.8125 C20.7852,12.4185 20.8832,11.9605 21.2012,11.6705 C21.4822,11.4155 21.6372,11.0745 21.6372,10.7105 C21.6372,9.9915 21.0532,9.4055 20.3322,9.4045 C20.3322,9.4045 20.1602,9.4085 19.8932,9.4085 C15.5102,9.4085 14.7272,8.6065 14.4712,8.3425 C14.1852,8.0505 14.0352,7.6775 14.0452,7.2925 C14.0472,6.9845 14.0622,6.6265 14.0962,6.2235 C14.1212,6.0025 14.1482,5.8275 14.1742,5.6575 C14.2072,5.4275 14.2402,5.2095 14.2562,5.0065 C14.4082,3.1365 13.9162,2.1945 13.6802,2.0035 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Power: () => (
    <svg
      viewBox='0 0 21 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='User-Mobile'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M13.9549,3.1642 C18.1719,4.6332 21.0059,8.6162 21.0059,13.0742 C21.0059,18.8662 16.2949,23.5772 10.5039,23.5772 C4.7109,23.5772 -0.000100000001,18.8662 -0.000100000001,13.0742 C-0.000100000001,8.6162 2.8339,4.6332 7.0509,3.1642 C7.5739,2.9812 8.1429,3.2582 8.3239,3.7792 C8.5059,4.3012 8.2309,4.8712 7.7089,5.0532 C4.2949,6.2422 1.9999,9.4662 1.9999,13.0742 C1.9999,17.7632 5.8149,21.5772 10.5039,21.5772 C15.1909,21.5772 19.0059,17.7632 19.0059,13.0742 C19.0059,9.4662 16.7129,6.2422 13.2969,5.0532 C12.7749,4.8712 12.4999,4.3012 12.6819,3.7792 C12.8629,3.2582 13.4319,2.9822 13.9549,3.1642 Z M10.5039,0.0004 C11.0569,0.0004 11.5039,0.4474 11.5039,1.0004 L11.5039,8.2754 C11.5039,8.8274 11.0569,9.2754 10.5039,9.2754 C9.9509,9.2754 9.5039,8.8274 9.5039,8.2754 L9.5039,1.0004 C9.5039,0.4474 9.9509,0.0004 10.5039,0.0004 Z'
          id='Combined-Shape'
          fill='#F2EEE8'
        />
      </g>
    </svg>
  ),
  Lock: () => (
    <svg
      viewBox='0 0 14 16'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='Desktop-HD-Copy'
          transform='translate(-556.000000, -349.000000)'
          fill='#1E1F22'
        >
          <g id='Group-7' transform='translate(542.000000, 207.000000)'>
            <g id='Group-3' transform='translate(0.000000, 131.000000)'>
              <path
                d='M15.5063368,26.1676524 L26.2148461,26.1676524 C26.4002414,26.1676524 26.5682559,26.0904043 26.6899215,25.9687387 C26.8115872,25.847073 26.8888352,25.6790585 26.8888352,25.4936632 L26.8888352,19.1361497 C26.8888352,18.9526856 26.8115872,18.7846711 26.6899215,18.6610742 C26.5682559,18.5413398 26.4002414,18.4640917 26.2148461,18.4640917 L24.3280628,18.4640917 L17.3969825,18.4640917 L15.5063368,18.4640917 C15.3209415,18.4640917 15.1509958,18.5413398 15.0312613,18.6610742 C14.9076645,18.7846711 14.8323476,18.9526856 14.8323476,19.1361497 L14.8323476,25.4936632 C14.8323476,25.6790585 14.9076645,25.847073 15.0312613,25.9687387 C15.1509958,26.0904043 15.3209415,26.1676524 15.5063368,26.1676524 L15.5063368,26.1676524 Z M21.4988533,20.4532287 C21.3347013,20.2910078 21.1087508,20.1886542 20.8596258,20.1886542 C20.6124321,20.1886542 20.3864816,20.2910078 20.2223295,20.4532287 C20.0581774,20.6173808 19.9596862,20.8414001 19.9596862,21.090525 C19.9596862,21.2372963 19.9944478,21.3802052 20.0581774,21.5038021 C20.1257695,21.6312613 20.2203983,21.7413398 20.3362704,21.8243814 C20.4424864,21.9016295 20.5100785,22.0232951 20.5100785,22.1642728 L20.5100785,24.1128546 L20.5120097,24.1128546 L20.5100785,24.1128546 C20.5100785,24.1476162 20.5255281,24.1804466 20.5487025,24.203621 C20.5718769,24.2267954 20.6047073,24.242245 20.6394689,24.242245 L20.6394689,24.2403138 L20.6394689,24.242245 L21.0778515,24.242245 C21.1068196,24.242245 21.1357876,24.2306578 21.158962,24.213277 L21.168618,24.2016898 C21.1917924,24.1785154 21.207242,24.145685 21.207242,24.1128546 L21.2091732,22.1835848 C21.2014484,22.0464695 21.2632468,21.9112855 21.3829813,21.8263126 C21.5007846,21.743271 21.5954134,21.6312613 21.6630054,21.5038021 C21.7267351,21.3802052 21.7614967,21.2392275 21.7614967,21.0924562 C21.7614967,20.8433313 21.6610742,20.6173808 21.4988533,20.4532287 L21.4988533,20.4532287 Z M20.8596258,19.360169 C20.3826192,19.360169 19.9500302,19.5532891 19.6371756,19.8642124 C19.3243211,20.177067 19.1292698,20.6115872 19.1292698,21.090525 C19.1292698,21.378274 19.1968618,21.6467109 19.3204587,21.8823174 C19.4112251,22.0619191 19.534822,22.22414 19.6815932,22.3593241 L19.679662,24.1128546 C19.679662,24.3754979 19.7878093,24.616898 19.9616174,24.7887749 C20.1334943,24.9645142 20.3748944,25.0726614 20.6394689,25.0726614 L20.6394689,25.0745926 L20.6394689,25.0726614 L21.0778515,25.0726614 C21.3289077,25.0726614 21.5567894,24.9761014 21.7286663,24.8196741 L21.7557031,24.7907061 C21.9295112,24.6188292 22.0376584,24.3774291 22.0376584,24.1128546 L22.0376584,22.3593241 C22.1844297,22.22414 22.3080266,22.0638503 22.4007242,21.8842486 C22.5223899,21.6467109 22.5919131,21.378274 22.5919131,21.0924562 C22.5919131,20.6135184 22.3968618,20.1789982 22.0859384,19.8661436 C21.7730839,19.5532891 21.3404949,19.360169 20.8596258,19.360169 L20.8596258,19.360169 Z M23.9128546,17.6317441 L23.9128546,16.6429692 C23.9128546,15.8009656 23.571032,15.03621 23.0206397,14.4858177 C22.466385,13.9334943 21.7054919,13.5916717 20.861557,13.5916717 C20.0214846,13.5916717 19.256729,13.9334943 18.7063368,14.4858177 C18.1540133,15.03621 17.8121907,15.8009656 17.8121907,16.6429692 L17.8121907,17.6317441 L23.9128546,17.6317441 Z M16.9817743,17.6317441 L16.9817743,16.6429692 C16.9817743,15.5711527 17.4143633,14.5997586 18.1192517,13.8968014 C18.8202776,13.1938443 19.7916717,12.7612553 20.861557,12.7612553 C21.9333736,12.7612553 22.9047677,13.1938443 23.6077248,13.8968014 C24.310682,14.5997586 24.7452022,15.5711527 24.7452022,16.6429692 L24.7452022,17.6317441 L25.6799034,17.6317441 L25.6799034,16.6468316 C25.6799034,15.9979481 25.5485818,15.3761014 25.3129753,14.8083283 C25.0696439,14.219312 24.7104406,13.6882317 24.2662643,13.2440555 C23.8240193,12.7998793 23.2910078,12.4406759 22.7039228,12.1973446 C22.1361497,11.9617381 21.514303,11.8284852 20.8654194,11.8284852 C20.2146047,11.8284852 19.5946892,11.9598069 19.0269161,12.1954134 C18.4378998,12.4406759 17.9048884,12.7960169 17.4607121,13.2421243 C17.0165359,13.6843693 16.6592637,14.2173808 16.4140012,14.8044659 C16.1783947,15.372239 16.047073,15.9940857 16.0451418,16.6429692 L16.0451418,17.6317441 L16.9817743,17.6317441 Z M26.2148461,27 L15.5063368,27 C15.0911285,27 14.7145444,26.8300543 14.442245,26.557755 C14.1699457,26.2854556 14,25.9088715 14,25.4936632 L14,19.1361497 C14,18.7228727 14.1699457,18.3462885 14.442245,18.0739891 C14.6508147,17.8654194 14.9173205,17.7186482 15.2185878,17.6607121 L15.2185878,16.6429692 C15.2185878,15.8782136 15.3711527,15.1501509 15.6453832,14.4858177 C15.9331322,13.796379 16.3522028,13.1726011 16.8755582,12.653108 C17.3969825,12.1316838 18.0188292,11.7126132 18.708268,11.4267954 C19.3726011,11.1525649 20.1006639,11 20.8654194,11 C21.630175,11 22.3582378,11.1525649 23.0225709,11.4267954 C23.7100785,11.7164756 24.3338564,12.1355462 24.8552806,12.6569704 C25.3747737,13.1783947 25.7938443,13.8002414 26.0815932,14.4916113 C26.3558238,15.1559445 26.5083887,15.8840072 26.5083887,16.6468316 L26.5064575,17.6607121 C26.8057936,17.7186482 27.0722993,17.8654194 27.2789378,18.0739891 C27.5512372,18.3462885 27.7192517,18.7228727 27.7192517,19.1361497 L27.7192517,25.4936632 C27.7192517,25.9088715 27.5512372,26.2854556 27.2789378,26.557755 C27.0066385,26.8300543 26.6300543,27 26.2148461,27 L26.2148461,27 Z'
                id='Fill-1'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  Data: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 2C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM13 9V3.5L18.5 9H13Z'
        fill='#323232'
      />
    </svg>
  ),
  Edit: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18.002 18.003'>
      <path
        d='M3,17.25V21H6.75L17.81,9.94,14.06,6.19ZM20.71,7.04a1,1,0,0,0,0-1.41L18.37,3.29a1,1,0,0,0-1.41,0L15.13,5.12l3.75,3.75,1.83-1.83Z'
        transform='translate(-3 -2.998)'
      />
    </svg>
  ),
  Error: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 19'>
      <path
        d='M1,21H23L12,2Zm12-3H11V16h2Zm0-4H11V10h2Z'
        transform='translate(-1 -2)'
      />
    </svg>
  ),
  Search: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 17.49 17.49'>
      <path
        d='M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z'
        transform='translate(-3 -3)'
      />
    </svg>
  ),
  ArrowLeft: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
      <path
        d='M20,11H7.83l5.59-5.59L12,4,4,12l8,8,1.41-1.41L7.83,13H20Z'
        transform='translate(-4 -4)'
      />
    </svg>
  ),
  Visible: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z'
        fill='#323232'
      />
    </svg>
  ),
  Invisible: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.74 7.01C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8V9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z'
        fill='#ffffff'
      />
    </svg>
  ),
  Filter: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V6.59C3 7.113 3.213 7.627 3.583 7.997L9 13.414V21C9.0002 21.1704 9.04387 21.3379 9.1269 21.4867C9.20992 21.6354 9.32955 21.7605 9.47444 21.8502C9.61934 21.9398 9.78471 21.9909 9.9549 21.9988C10.1251 22.0066 10.2945 21.9709 10.447 21.895L14.447 19.895C14.786 19.725 15 19.379 15 19V13.414L20.417 7.997C20.787 7.627 21 7.113 21 6.59V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3ZM13.293 12.293C13.2 12.3857 13.1262 12.4959 13.0759 12.6172C13.0256 12.7386 12.9998 12.8687 13 13V18.382L11 19.382V13C11.0002 12.8687 10.9744 12.7386 10.9241 12.6172C10.8738 12.4959 10.8 12.3857 10.707 12.293L5 6.59V5H19.001L19.003 6.583L13.293 12.293Z'
        fill='white'
      />
    </svg>
  ),
  Dropdown: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 5'>
      <path d='M7,10l5,5,5-5Z' transform='translate(-7 -10)' />
    </svg>
  ),
  CheckboxChecked: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z'
        fill='#323232'
      />
    </svg>
  ),
  CheckboxUnchecked: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z'
        fill='#323232'
      />
    </svg>
  ),
  ClosePopup: () => (
    <svg
      width='14'
      height='13'
      viewBox='0 0 14 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.40994 6.91889L12.7099 2.62889C12.8982 2.44058 13.004 2.18519 13.004 1.91889C13.004 1.65259 12.8982 1.39719 12.7099 1.20889C12.5216 1.02058 12.2662 0.914795 11.9999 0.914795C11.7336 0.914795 11.4782 1.02058 11.2899 1.20889L6.99994 5.50889L2.70994 1.20889C2.52164 1.02058 2.26624 0.914795 1.99994 0.914795C1.73364 0.914795 1.47824 1.02058 1.28994 1.20889C1.10164 1.39719 0.995847 1.65259 0.995847 1.91889C0.995847 2.18519 1.10164 2.44058 1.28994 2.62889L5.58994 6.91889L1.28994 11.2089C1.19621 11.3019 1.12182 11.4124 1.07105 11.5343C1.02028 11.6562 0.994141 11.7869 0.994141 11.9189C0.994141 12.0509 1.02028 12.1816 1.07105 12.3035C1.12182 12.4253 1.19621 12.5359 1.28994 12.6289C1.3829 12.7226 1.4935 12.797 1.61536 12.8478C1.73722 12.8985 1.86793 12.9247 1.99994 12.9247C2.13195 12.9247 2.26266 12.8985 2.38452 12.8478C2.50638 12.797 2.61698 12.7226 2.70994 12.6289L6.99994 8.32889L11.2899 12.6289C11.3829 12.7226 11.4935 12.797 11.6154 12.8478C11.7372 12.8985 11.8679 12.9247 11.9999 12.9247C12.132 12.9247 12.2627 12.8985 12.3845 12.8478C12.5064 12.797 12.617 12.7226 12.7099 12.6289C12.8037 12.5359 12.8781 12.4253 12.9288 12.3035C12.9796 12.1816 13.0057 12.0509 13.0057 11.9189C13.0057 11.7869 12.9796 11.6562 12.9288 11.5343C12.8781 11.4124 12.8037 11.3019 12.7099 11.2089L8.40994 6.91889Z'
        fill='black'
      />
    </svg>
  ),
  ActionEditIcon: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 17.2505V21.0005H6.75L17.81 9.94055L14.06 6.19055L3 17.2505ZM20.71 7.04055C21.1 6.65055 21.1 6.02055 20.71 5.63055L18.37 3.29055C17.98 2.90055 17.35 2.90055 16.96 3.29055L15.13 5.12055L18.88 8.87055L20.71 7.04055Z'
        fill='#7759de'
      />
    </svg>
  ),
  ActionMoreIcon: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7 13.5C6.17 13.5 5.5 12.83 5.5 12C5.5 11.17 6.17 10.5 7 10.5C7.83 10.5 8.5 11.17 8.5 12C8.5 12.83 7.83 13.5 7 13.5ZM12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5ZM17 13.5C16.17 13.5 15.5 12.83 15.5 12C15.5 11.17 16.17 10.5 17 10.5C17.83 10.5 18.5 11.17 18.5 12C18.5 12.83 17.83 13.5 17 13.5Z'
        fill='#4680ff'
      />
    </svg>
  ),
  ActionOrders: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM19 11H9V9H19V11ZM15 15H9V13H15V15ZM19 7H9V5H19V7Z'
        fill='#4680ff'
      />
    </svg>
  ),
  SwapUp: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        fill='none'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        transform='translate(3 3)'
      >
        <path d='m3.5 7.5 4-4 4 4' />
        <path d='m7.5 3.5v11' />
        <path d='m.5.5h14' />
      </g>
    </svg>
  ),
  SwapDown: () => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g
        fill='none'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        transform='translate(4 3)'
      >
        <path d='m2.5 7.5 4 4.232 4-4.191' />
        <path d='m6.5.5v11' />
        <path d='m.5 14.5h12' />
      </g>
    </svg>
  ),
  UserParticipationIcon: () => (
    <svg
      width='24'
      height='12'
      viewBox='0 0 24 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 6.75C13.63 6.75 15.07 7.14 16.24 7.65C17.32 8.13 18 9.21 18 10.38V12H6V10.39C6 9.21 6.68 8.13 7.76 7.66C8.93 7.14 10.37 6.75 12 6.75ZM4 7C5.1 7 6 6.1 6 5C6 3.9 5.1 3 4 3C2.9 3 2 3.9 2 5C2 6.1 2.9 7 4 7ZM5.13 8.1C4.76 8.04 4.39 8 4 8C3.01 8 2.07 8.21 1.22 8.58C0.48 8.9 0 9.62 0 10.43V12H4.5V10.39C4.5 9.56 4.73 8.78 5.13 8.1ZM20 7C21.1 7 22 6.1 22 5C22 3.9 21.1 3 20 3C18.9 3 18 3.9 18 5C18 6.1 18.9 7 20 7ZM24 10.43C24 9.62 23.52 8.9 22.78 8.58C21.93 8.21 20.99 8 20 8C19.61 8 19.24 8.04 18.87 8.1C19.27 8.78 19.5 9.56 19.5 10.39V12H24V10.43ZM12 0C13.66 0 15 1.34 15 3C15 4.66 13.66 6 12 6C10.34 6 9 4.66 9 3C9 1.34 10.34 0 12 0Z'
        fill='#199248'
      />
    </svg>
  ),
  TotalPackageIcon: () => (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.99 16.54L1.62 10.81L0 12.07L9 19.07L18 12.07L16.37 10.8L8.99 16.54ZM9 14L16.36 8.27L18 7L9 0L0 7L1.63 8.27L9 14Z'
        fill='#f3ba2f'
      />
    </svg>
  ),
  TotalRefundIcon: () => (
    <svg
      width='16'
      height='22'
      viewBox='0 0 16 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 3V0L4 4L8 8V5C11.31 5 14 7.69 14 11C14 12.01 13.75 12.97 13.3 13.8L14.76 15.26C15.54 14.03 16 12.57 16 11C16 6.58 12.42 3 8 3ZM8 17C4.69 17 2 14.31 2 11C2 9.99 2.25 9.03 2.7 8.2L1.24 6.74C0.46 7.97 0 9.43 0 11C0 15.42 3.58 19 8 19V22L12 18L8 14V17Z'
        fill='#f3ba2f'
      />
    </svg>
  ),
  TotalVolumeIcon: () => (
    <svg
      width='11'
      height='18'
      viewBox='0 0 11 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.80007 7.9C3.53007 7.31 2.80007 6.7 2.80007 5.75C2.80007 4.66 3.81007 3.9 5.50007 3.9C7.28007 3.9 7.94007 4.75 8.00007 6H10.2101C10.1401 4.28 9.09007 2.7 7.00007 2.19V0H4.00007V2.16C2.06007 2.58 0.500068 3.84 0.500068 5.77C0.500068 8.08 2.41007 9.23 5.20007 9.9C7.70007 10.5 8.20007 11.38 8.20007 12.31C8.20007 13 7.71007 14.1 5.50007 14.1C3.44007 14.1 2.63007 13.18 2.52007 12H0.320068C0.440068 14.19 2.08007 15.42 4.00007 15.83V18H7.00007V15.85C8.95007 15.48 10.5001 14.35 10.5001 12.3C10.5001 9.46 8.07007 8.49 5.80007 7.9Z'
        fill='#f3ba2f'
      />
    </svg>
  ),
  TotalOrdersIcon: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 9V16H2V9H0V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V9H16ZM10 9.67L12.59 7.09L14 8.5L9 13.5L4 8.5L5.41 7.09L8 9.67V0H10V9.67Z'
        fill='#0466c8'
      />
    </svg>
  ),
  SwapUpIcon: () => (
    <svg
      width='30'
      height='16'
      viewBox='0 0 30 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.1423 15.0024L15.0001 0.860263L0.857988 15.0024H29.1423Z'
        fill='#7759de'
      />
    </svg>
  ),
  SwapDownIcon: () => (
    <svg
      width='30'
      height='15'
      viewBox='0 0 30 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.857863 -0.000441551L15 14.1417L29.1421 -0.000441551H0.857863Z'
        fill='#0466c8'
      />
    </svg>
  ),
  AddNewIcon: () => (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13 8H8V13C8 13.55 7.55 14 7 14C6.45 14 6 13.55 6 13V8H1C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6H6V1C6 0.45 6.45 0 7 0C7.55 0 8 0.45 8 1V6H13C13.55 6 14 6.45 14 7C14 7.55 13.55 8 13 8Z'
        fill='black'
      />
    </svg>
  ),
  Copy: () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.545 18'>
      <path
        className='a'
        d='M13.455,1H3.636A1.641,1.641,0,0,0,2,2.636V14.091H3.636V2.636h9.818Zm2.455,3.273h-9A1.641,1.641,0,0,0,5.273,5.909V17.364A1.641,1.641,0,0,0,6.909,19h9a1.641,1.641,0,0,0,1.636-1.636V5.909A1.641,1.641,0,0,0,15.909,4.273Zm0,13.091h-9V5.909h9Z'
        transform='translate(-2 -1)'
      />
    </svg>
  ),
  LockUserIcon: () => (
    <svg
      width='18'
      height='22'
      viewBox='0 0 18 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 20.78L1.22 4L0 5.22L2.04 7.26C1.42 7.6 1 8.25 1 9V19C1 20.1 1.9 21 3 21H15C15.23 21 15.45 20.95 15.66 20.88L16.78 22L18 20.78ZM5.9 5C5.9 3.29 7.29 1.9 9 1.9C10.71 1.9 12.1 3.29 12.1 5V7H6.66L17 17.34V9C17 7.9 16.1 7 15 7H14V5C14 2.24 11.76 0 9 0C6.44 0 4.36 1.93 4.06 4.4L5.9 6.24V5Z'
        fill='#ffffff'
      />
    </svg>
  ),
  UnlockUserIcon: () => (
    <svg
      width='16'
      height='21'
      viewBox='0 0 16 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM8 16C6.9 16 6 15.1 6 14C6 12.9 6.9 12 8 12C9.1 12 10 12.9 10 14C10 15.1 9.1 16 8 16ZM11.1 7H4.9V5C4.9 3.29 6.29 1.9 8 1.9C9.71 1.9 11.1 3.29 11.1 5V7Z'
        fill='#323232'
      />
    </svg>
  ),
  BalanceIcon: () => (
    <svg
      width='21'
      height='21'
      viewBox='0 0 55 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='38.0091'
        cy='16.7788'
        r='16.7788'
        fill='white'
        fillOpacity='0.67'
      ></circle>
      <circle
        cx='17.4636'
        cy='16.7788'
        r='16.7788'
        fill='white'
        fillOpacity='0.67'
      ></circle>
    </svg>
  ),
  ViewDetailIcon: () => (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 0V2H11.59L0 13.59L1.41 15L13 3.41V10H15V0H5Z'
        fill='#ffffff'
      />
    </svg>
  ),
  ConfirmStatus: () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z'
        fill='#323232'
      />
    </svg>
  ),
  TimestampIcon: () => (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z'
        fill='#323232'
      />
      <path
        d='M10.5 5H9V11L14.25 14.15L15 12.92L10.5 10.25V5Z'
        fill='#323232'
      />
    </svg>
  ),
  BlockIcon: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.73 0H5.27L0 5.27V12.73L5.27 18H12.73L18 12.73V5.27L12.73 0ZM14 12.74L12.74 14L9 10.26L5.26 14L4 12.74L7.74 9L4 5.26L5.26 4L9 7.74L12.74 4L14 5.26L10.26 9L14 12.74Z'
        fill='#323232'
      />
    </svg>
  ),
  UnblockIcon: () => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z'
        fill='#323232'
      />
    </svg>
  ),
  Menu: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='24'
      height='24'
    >
      <path fill='none' d='M0 0h24v24H0z' />
      <path
        fill='currentColor'
        d='M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'
      />
    </svg>
  ),

  Eye: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      fill='#ffffff'
      version='1.1'
      viewBox='0 0 442.04 442.04'
      xmlSpace='preserve'
    >
      <path d='M221.02 341.304c-49.708 0-103.206-19.44-154.71-56.22-38.502-27.494-62.266-54.733-63.259-55.881a12.5 12.5 0 010-16.367c.993-1.146 24.756-28.387 63.259-55.881 51.505-36.777 105.003-56.219 154.71-56.219 49.708 0 103.207 19.441 154.71 56.219 38.502 27.494 62.266 54.734 63.259 55.881a12.5 12.5 0 010 16.367c-.993 1.146-24.756 28.387-63.259 55.881-51.503 36.779-105.001 56.22-154.71 56.22zM29.638 221.021c9.61 9.799 27.747 27.03 51.694 44.071 32.83 23.361 83.714 51.212 139.688 51.212s106.859-27.851 139.688-51.212c23.944-17.038 42.082-34.271 51.694-44.071-9.609-9.799-27.747-27.03-51.694-44.071-32.829-23.362-83.714-51.212-139.688-51.212s-106.858 27.85-139.688 51.212c-23.944 17.038-42.082 34.269-51.694 44.071z'></path>
      <path d='M221.02 298.521c-42.734 0-77.5-34.767-77.5-77.5s34.766-77.5 77.5-77.5a77.436 77.436 0 0151.048 19.188c5.193 4.549 5.715 12.446 1.166 17.639-4.549 5.193-12.447 5.714-17.639 1.166a52.448 52.448 0 00-34.576-12.993c-28.949 0-52.5 23.552-52.5 52.5s23.551 52.5 52.5 52.5c28.95 0 52.5-23.552 52.5-52.5 0-6.903 5.597-12.5 12.5-12.5s12.5 5.597 12.5 12.5c.002 42.733-34.765 77.5-77.499 77.5z'></path>
      <path d='M221.02 246.021c-13.785 0-25-11.215-25-25s11.215-25 25-25c13.786 0 25 11.215 25 25s-11.214 25-25 25z'></path>
    </svg>
  ),

  Trash: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      fill='#F8F8FF'
      version='1.1'
      viewBox='0 0 512 512'
      xmlSpace='preserve'
    >
      <path d='M465.423 48.241h-137.61V23.955C327.813 10.746 317.082 0 303.893 0h-95.785c-13.19 0-23.92 10.746-23.92 23.955V48.24H46.577c-6.655 0-12.049 5.394-12.049 12.049 0 6.655 5.394 12.049 12.049 12.049h22.332l15.228 396.396A44.858 44.858 0 00129.099 512h253.804a44.855 44.855 0 0044.96-43.267l15.228-396.396h22.332c6.653 0 12.049-5.394 12.049-12.049 0-6.653-5.394-12.047-12.049-12.047zM208.285 24.097h95.43V48.24h-95.43V24.097zm195.499 443.712a20.833 20.833 0 01-20.882 20.094H129.099a20.835 20.835 0 01-20.882-20.095L93.025 72.338h325.952l-15.193 395.471z'></path>
      <path d='M182.63 181.571c-.127-6.575-5.494-11.817-12.042-11.817-.078 0-.158 0-.236.002-6.652.128-11.943 5.626-11.815 12.278l3.781 196.634c.126 6.575 5.495 11.817 12.042 11.817.078 0 .158 0 .236-.002 6.653-.128 11.943-5.624 11.815-12.278l-3.781-196.634zM255.998 169.753c-6.654 0-12.049 5.394-12.049 12.049v196.634c0 6.654 5.394 12.049 12.049 12.049 6.655 0 12.049-5.394 12.049-12.049V181.802c0-6.654-5.394-12.049-12.049-12.049zM341.645 169.756c-6.628-.147-12.151 5.162-12.278 11.815l-3.781 196.634c-.129 6.653 5.162 12.15 11.815 12.278l.236.002c6.546 0 11.916-5.244 12.042-11.817l3.781-196.634c.128-6.654-5.161-12.151-11.815-12.278z'></path>
    </svg>
  ),

  PlusMinus: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      fill='#F8F8FF'
      version='1.1'
      viewBox='0 0 141.293 141.293'
      xmlSpace='preserve'
    >
      <path d='M77.955 109.975a7.31 7.31 0 000 14.618h56.029a7.308 7.308 0 007.309-7.31 7.308 7.308 0 00-7.309-7.308H77.955zM0 44.2a7.308 7.308 0 007.309 7.308h19.489v19.49a7.308 7.308 0 1014.617 0v-19.49H63.34a7.307 7.307 0 007.308-7.308 7.308 7.308 0 00-7.308-7.309H41.414V12.53a7.308 7.308 0 00-7.309-7.308 7.307 7.307 0 00-7.308 7.308v24.361H7.308A7.31 7.31 0 000 44.2zM131.428 17.261a7.307 7.307 0 00-10.336 0L14.763 123.594a7.308 7.308 0 000 10.334 7.277 7.277 0 005.167 2.143 7.287 7.287 0 005.169-2.143L131.428 27.599a7.31 7.31 0 000-10.338z'></path>
    </svg>
  ),

  Reload: () => (
    <svg
      fill='#323232'
      height='22'
      width='22'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 383.748 383.748'
    >
      <g>
        <path
          d='M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30
		C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593
		L2.081,34.641v113.365h113.91L62.772,95.042z'
        />
        <path
          d='M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042
		c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888
		c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z'
        />
      </g>
    </svg>
  ),

  Prev: () => (
    <svg
      viewBox='0 0 6 10'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='Mainboard-Copy-2'
          transform='translate(-1225.000000, -706.000000)'
          fill='#F8F8FF'
          fillRule='nonzero'
        >
          <g id='Group-11' transform='translate(31.000000, 108.000000)'>
            <g
              id='Group-24-Copy'
              transform='translate(1194.000000, 595.000000)'
            >
              <path
                d='M5.49527827,8.49505142 L1.19543784,12.7947591 C0.921916047,13.0684136 0.478447351,13.0684136 0.205058349,12.7947591 C-0.0683527831,12.5213479 -0.0683527831,12.0779014 0.205058349,11.8045124 L4.0097533,7.99992807 L0.205169006,4.19547657 C-0.0682421262,3.92195478 -0.0682421262,3.47855247 0.205169006,3.20514134 C0.478580139,2.93161955 0.922026704,2.93161955 1.19554849,3.20514134 L5.49538893,7.50491538 C5.63209449,7.64168734 5.70036982,7.82075238 5.70036982,7.99990594 C5.70036982,8.17914803 5.6319617,8.35834586 5.49527827,8.49505142 Z'
                id='Path-Copy'
                transform='translate(2.850185, 8.000000) scale(-1, 1) translate(-2.850185, -8.000000) '
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),

  Next: () => (
    <svg
      viewBox='0 0 6 10'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <g
        id='Page-1'
        stroke='none'
        strokeWidth={1}
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='Mainboard-Copy-2'
          transform='translate(-1315.000000, -706.000000)'
          fill='#F8F8FF'
          fillRule='nonzero'
        >
          <g id='Group-11' transform='translate(31.000000, 108.000000)'>
            <g
              id='Group-24-Copy'
              transform='translate(1194.000000, 595.000000)'
            >
              <path
                d='M95.4952783,8.49505142 L91.1954378,12.7947591 C90.921916,13.0684136 90.4784474,13.0684136 90.2050583,12.7947591 C89.9316472,12.5213479 89.9316472,12.0779014 90.2050583,11.8045124 L94.0097533,7.99992807 L90.205169,4.19547657 C89.9317579,3.92195478 89.9317579,3.47855247 90.205169,3.20514134 C90.4785801,2.93161955 90.9220267,2.93161955 91.1955485,3.20514134 L95.4953889,7.50491538 C95.6320945,7.64168734 95.7003698,7.82075238 95.7003698,7.99990594 C95.7003698,8.17914803 95.6319617,8.35834586 95.4952783,8.49505142 Z'
                id='Path'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),

  Print: () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='#F8F8FF'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <rect x='4' y='4' width='16' height='16' rx='2' ry='2'></rect>
      <path d='M4 20v2'></path>
      <path d='M20 20v2'></path>
      <path d='M6 16h12'></path>
    </svg>
  ),
};
